import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import SecureModuleIndex from "../secure/SecureModuleIndex";
import bgImage from "../../images/loginBackgrounds/unsplash.png";
import bgBottom from "../../images/loginBackgrounds/bottom-mtn.png";
import mtnLogo from "../../images/DEQ_Logos/Mountain-Logo-Utah-DW-2.svg";
import { appConfig } from "../../configuration/AppConfig";
import FakeLink from "../reuseableComponents/FakeLink";

const RequestPortalAccess = (props) => {

  const { user } = useContext(UserContext);

  const bottomSectionStyle = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundImage: `url(${bgBottom})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingTop: "120px"
  };

  const bottomContentStyle = {
    textAlign: "center",
    maxWidth: "80%",
    margin: "auto",
    color: "#157995",
    fontSize: "28px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  };

  const numberedCircleStyle = {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    border: "2px solid #157995",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "10px",
    color: "#157995",
    fontSize: "18px",
    fontWeight: "bold",
  };

  const stepStyle = {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "20px",
  };

  const stepContentStyle = {
    textAlign: "left",
    marginLeft: "10px",
  };

  const smallTextStyle = {
    fontSize: "15px", 
    color: "black",
  };

  return (
    <>
      {user.isPublic ? (
        <Row>
          <Col>
            <div id="landingPageContainer">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", maxWidth: "100vw", backgroundImage: `url(${bgImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
                <div style={{ paddingBottom: "80px", alignItems: "center" }}>
                  <div style={{ textAlign: "center", maxWidth: "60%", margin: "auto" }}>
                    <img src={mtnLogo} alt='Mountain Logo' style={{ maxWidth: "100%", objectFit: "contain" }} />
                  </div>
                  <br/>
                  <p style={{ maxWidth: "80%", textAlign: "center", fontWeight: "bold", fontSize: "42px", color: "#fff", margin: "auto", objectFit: "contain" }}>
                    Portal Access
                  </p>
                  <br/>
                </div>
                <div style={bottomSectionStyle}>
                  <div style={bottomContentStyle}>
                    <div style={stepStyle}>
                      <div style={numberedCircleStyle}>1</div>
                      <div style={stepContentStyle}>
                        <p className="u-fs-m u-text-teal-dark" style={{ fontSize: '20px',fontWeight: "bold"}}>Sign In to Waterlink or Create a Utah ID Account</p>
                        <p style={smallTextStyle}>
                        To access the portal{" "}
                        <FakeLink
                          url="https://id.utah.gov/login"
                          style={{ color: "#0D6EFD", cursor: "pointer" }}
                          onClick={() => window.location.assign(`${appConfig.authEndpoint}${appConfig.authParams}`)}
                        >
                          sign in.
                        </FakeLink>
                        </p>
                        <p style={smallTextStyle}>
                          To create an account <a href="https://login.utah.gov/user/create" target="_blank" rel="noopener noreferrer" className="u-link u-text-teal-dark">click here</a>.
                        </p>
                      </div>
                    </div>
                    <div style={stepStyle}>
                      <div style={numberedCircleStyle}>2</div>
                      <div style={stepContentStyle}>
                        <p className="u-fs-m u-text-teal-dark" style={{ fontSize: '20px',fontWeight: "bold" }}>Request Access to Portal</p>
                        <p style={smallTextStyle}>
                          After signing in, fill out and submit the Request Access Form.
                        </p>
                        <p style={smallTextStyle}>We will review your request.</p>
                        <p style={smallTextStyle}>When approved you will receive an email.</p>
                      </div>
                    </div>

                    <div style={stepStyle}>
                      <div style={numberedCircleStyle}>3</div>
                      <div style={stepContentStyle}>
                        <p className="u-fs-m u-text-teal-dark" style={{ fontSize: '20px',fontWeight: "bold" }}>Sign In and Get to Work</p>
                        <p style={smallTextStyle}>
                          You should now have access to all the tools you need.
                        </p>
                        <p style={smallTextStyle}>Enjoy</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <SecureModuleIndex />
      )}
    </>
  );
};
export default RequestPortalAccess;
